<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app
    :style="{
      backgroundImage: 'url(' + require('@/assets/img/bgLogin.jpg') + ')',
      backgroundSize: 'cover',
      minHeight: '100vh',
    }"
  >
      <div class="lang">
        <v-layout row wrap align-center justify-end>
          <v-flex xs1 sm4 md5 lg5>
            <img
            :src="require('@/assets/img/thailand.png')"
              width="10%"
              alt=""
              v-if="$t('default') === 'th'"
            />
            <img
            :src="require('@/assets/img/united-kingdom.png')"
              width="10%"
              alt=""
              v-if="$t('default') === 'en'"
            />
          </v-flex>
          <v-flex
            xs3
            sm2
            md1
            lg1
            class="black--text mr-5 fontSize"
            @click="fn_changelanguage('th')"
          >
            <b>TH</b>
          </v-flex>
          <v-divider inset vertical color="black" class="mt-2"></v-divider>
          <v-flex
            xs3
            sm3
            md2
            lg2
            class="black--text ml-4 fontSize"
            @click="fn_changelanguage('en')"
          >
            <b> EN</b>
          </v-flex>
          <v-flex md2 lg2 class="black--text mr-2"></v-flex>
        </v-layout>
      </div>
      <div class="center">
        <div class="center-card">
          <img
            :src="require('@/assets/img/logoINETCMP.png')"
            width="300"
            alt="cmp"
            class="mt-n5"
          />
          <h2>Consent Management Platform (CMP)</h2>
          <br />
          <br />
          <div v-if="ShowLogin">
            <v-layout row wrap justify-center align-center pb-4>
              <v-flex xs9 sm9 md9 lg9>
                <div class="borderTitle">
                  <img
                    src="https://one.th/img/logo_one platform for light background.png"
                    width="55"
                    alt="alt"
                  />
                  <a @click="fn_getOneID">
                    <span class="ml-2"> {{ $t("Login.AccessVia") }}</span>
                  </a>
                </div>

                <div class="pt-2">
                  <a href="https://one.th/register" class="fontSizeSub">
                    {{ $t("Login.registerOne") }}</a
                  >
                </div>
                <!-- <v-btn
                  block
                  large
                  color="#077893"
                  elevation="2"
                  :loading="loadingLogin"
                  @click="fn_getOneID"
                  target="_blank"
                >
                  {{ $t("Login.btnLogin") }}</v-btn
                > -->
              </v-flex>
              <v-flex xs11 sm11 md11 lg11 pt-8 pb-8>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs9 sm9 md9 lg9 pt-1>
                <v-btn block large outlined color="#077893" @click="fn_sentOtp">
                  <v-icon left>mdi-email-outline</v-icon>
                  {{ $t("Login.loginEmail") }}</v-btn
                >
              </v-flex>
            </v-layout>
          </div>
          <v-layout
            row
            wrap
            justify-center
            align-center
            v-else-if="ShowOtp"
            mt-n7
          >
            <v-flex xs11 sm11 md11 lg11>
              <h3 class="text-left">ยืนยันรหัส OTP</h3>
              <h4 class="text-left pb-5">
                กรุณากรอกรหัส OTP 6 หลัก RefCode: {{ ItemsOtp.REF }}
              </h4>
              <v-otp-input
                dense
                v-model="InputOtp"
                length="6"
                type="number"
              ></v-otp-input>
            </v-flex>
            <v-flex xs11 sm11 md11 lg11 pt-2>
              <p class="pb-2 mb-0 mt-3 p1-submitOTP1">
                OTP จะมีอายุการใช้งาน
                <span class="font-weight-medium orange--text text--darken-2">
                  {{ MinutesOtp.toString().padStart(2, "0") }}:{{
                    SecondsOtp.toString().padStart(2, "0")
                  }}</span
                >
                นาที
              </p>
            </v-flex>
            <v-flex xs11 sm11 md11 lg11>
              <v-btn
                @click="Fn_ConfirmOtp"
                :loading="LoadingOtp"
                large
                color="#077893"
                :disabled="InputOtp < 6"
                >ยืนยัน otp</v-btn
              >
            </v-flex>
          </v-layout>
          <div v-else>
            <v-form ref="formOtp" v-model="valid" lazy-validation>
              <v-layout row wrap justify-center align-center>
                <v-flex xs11 sm11 md11 lg11>
                  <v-text-field
                    :label="$t('Toolbar.email')"
                    outlined
                    dense
                    :rules="RuleEmail"
                    v-model="EmailOtp"
                    prepend-inner-icon="mdi-email-outline"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
                justify-end
                align-center
                class="mb-16 PaddingPolicy"
              >
                <v-flex xs3 sm3 md3 lg3>
                  <v-btn
                    color="#077893"
                    :loading="LoadingEmail"
                    @click="fn_sentOtp"
                    >ขอรหัส otp</v-btn
                  >
                </v-flex>
                <v-flex xs3 sm3 md3 lg3>
                  <v-btn color="#077893" outlined @click="Fn_CancelOtp"
                    >ยกเลิก</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <v-layout row wrap justify-center align-center pt-10>
            <v-flex xs11 sm11 md11 lg11>
              <v-btn x-large color="light-blue" text @click="fn_openDialogTerm">
                {{ $t("Login.TermsandConditions") }}</v-btn
              >
              <div class="mt-n4 mb-6">
                <a
                  href="https://one.th/privacy-policy"
                  target="blank"
                  class="fontSize"
                >
                  <v-btn color="light-blue " text>
                    {{ $t("Login.protectionpolicy") }}</v-btn
                  >
                </a>
              </div>
              <p class="fontSize">
                <v-icon>mdi-copyright</v-icon>
                powered by <span>INET</span>
              </p>
            </v-flex>
          </v-layout>
        </div>
      </div>
    <DialogTerm :show="DialogTerm" @closeDialogTerm="DialogTerm = false" />
  </v-app>
</template>

<script>
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
import { mapState } from 'vuex'
import DialogTerm from '../dialog/DialogTermCodition.vue'
const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})

export default {
  components: { DialogTerm },

  data () {
    return {
      valid: true,
      Token: '',
      ClientId: '',
      Url: process.env.VUE_APP_LOGIN,
      Code: 'code',
      PathUrl: '',
      InputOtp: 0,
      MinutesOtp: 0,
      SecondsOtp: 0,
      ItemsOtp: [],
      Interval: null,
      loading: false,
      EmailOtp: '',
      DialogTerm: false,
      LoadingOtp: false,
      ShowLogin: true,
      ShowOtp: false,
      LoadingEmail: false,
      AccessTokenEmail: '',
      ItemsEmail: '',
      RuleEmail: [
        (v) => !!v || 'กรุณากรอกอีเมล',
        (v) => /.+@.+\..+/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง'
      ]
    }
  },

  mounted () {
    if ('code' in this.$route.query) {
      this.Token = this.$route.query.code
      const payload = {
        Token: this.Token,
        RedirectURL: process.env.VUE_APP_PATH_LOCAL
      }
      this.loading = true
      this.$store.dispatch('SET_LOADING_LOGIN', true)
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'token/loginBySSO',
          payload
        )
        .then((response) => {
          this.loading = false
          this.$store.dispatch('SET_LOADING_LOGIN', false)
          if (response.data.Status === 'OK') {
            Toast.fire({
              icon: 'success',
              title: this.$i18n.t('alert.login')
            })
            this.$store.dispatch('GET_MENU_DEFAULT', [])
            this.$cookies.set('BusinessId', '00000')
            this.$cookies.set('OneUsername', response.data.Message.Username)
            this.$cookies.set('OneAccountId', response.data.Message.AccountId)
            this.$cookies.set(
              'OneAccessToken',
              response.data.Message.AccessToken,
              '1d'
            )
            this.$cookies.set(
              'OneRefreshToken',
              response.data.Message.RefreshToken,
              '1d'
            )
            this.$router.push('/profile')
          } else {
            this.$store.dispatch('SET_LOADING_LOGIN', false)
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.$store.dispatch('SET_LOADING_LOGIN', false)
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title:
                this.$i18n.t('alert.contactserve') +
                error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: this.$i18n.t('alert.contactserve') + error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title:
                this.$i18n.t('alert.contactserve') + error.message || error
            })
          }
          this.loading = false
        })
    }
  },

  methods: {
    Fn_CancelOtp () {
      this.EmailOtp = ''
      this.ShowLogin = true
    },
    fn_sentOtp () {
      this.ShowLogin = false
      if (this.$refs.formOtp.validate()) {
        this.LoadingEmail = true
        var payload = {
          Email: this.EmailOtp
        }

        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + 'token/login/otp/email',
            payload
          )
          .then((response) => {
            this.LoadingEmail = false
            if (response.data.Status === 'OK') {
              this.ItemsOtp = response.data.Message
              this.ShowOtp = true
              clearInterval(this.interval)
              this.fn_timeCountDown(this.ItemsOtp.Timeout)
            } else {
              Toast.fire({
                icon: 'error',
                title: response.data.ErrorMessage
              })
            }
          })
          .catch((error) => {
            this.LoadingEmail = false
            if (error.response) {
              Toast.fire({
                icon: 'error',
                title: error.response.data.ErrorMessage
              })
            } else if (error.request) {
              Toast.fire({
                icon: 'error',
                title: error.request
              })
            } else {
              Toast.fire({
                icon: 'error',
                title: error.message || error
              })
            }
          })
      }
    },
    Fn_ConfirmOtp () {
      this.LoadingOtp = true
      var payload = {
        OTP: this.InputOtp,
        REF: this.ItemsOtp.REF,
        Email: this.EmailOtp,
        Login: this.ItemsOtp.TicketId
      }

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'token/login/otp/email/verify',
          payload
        )
        .then((response) => {
          this.LoadingOtp = false
          if (response.data.Status === 'OK') {
            this.AccessTokenEmail = response.data.Message
            this.Fn_LoginEmailSuccess()
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.LoadingOtp = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    Fn_LoginEmailSuccess () {
      this.LoadingOtp = true
      var payload = {
        AccessToken: this.AccessTokenEmail
      }

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'token/get/account/login/email',
          payload
        )
        .then((response) => {
          this.LoadingOtp = false
          if (response.data.Status === 'OK') {
            this.ItemsEmail = response.data.Message
            this.$cookies.set('EmailCMP', response.data.Message.Email)
            this.$cookies.set(
              'EmailAccessToken',
              response.data.Message.AccessToken
            )
            this.$router.push('/consent-list-email')
            Toast.fire({
              icon: 'success',
              title: this.$t('alert.login')
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.LoadingOtp = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    fn_clearData () {
      this.$cookies.remove('OneUsername')
      this.$cookies.remove('OneAccountId')
      this.$cookies.remove('OneAccessToken')
      this.$cookies.remove('OneRefreshToken')
      this.$cookies.remove('Timestamps')
      this.$cookies.remove('RoleAccount')
      this.$cookies.remove('BusinessSelect')
      this.$cookies.remove('BusinessId')
      this.$cookies.remove('TaxIdCMP')
      this.$cookies.remove('CheckAdminName')
      this.$cookies.remove('RoleAccountId')
      localStorage.removeItem('BusinessNameTH')
      localStorage.removeItem('BusinessNameEng')
      localStorage.removeItem('OneTaxId')
      localStorage.removeItem('lang')
      this.$cookies.remove('includesRolename')
    },
    fn_getOneID: function () {
      this.fn_clearData()
      this.PathUrl =
        process.env.VUE_APP_PATH_GET_ONEID +
        this.Url +
        '&response_type=' +
        this.Code +
        '&redirect_uri=' +
        process.env.VUE_APP_PATH_LOCAL
      window.location.href = this.PathUrl
    },
    // ฟังก์ชั่นนับเวลา "Expire OTP"
    fn_timeCountDown (Timeout) {
      let time = Timeout * 60
      this.Interval = setInterval(() => {
        this.MinutesOtp = Math.floor(time / 60)
        this.SecondsOtp = time % 60
        time--
        if (time === 0) {
          clearInterval(this.Interval)
        }
      }, 1000)
    },

    fn_changelanguage (language) {
      if (language === 'th') {
        localStorage.setItem('lang', 'th')
        this.$i18n.locale = 'th'
      } else if (language === 'en') {
        localStorage.setItem('lang', 'en')
        this.$i18n.locale = 'en'
      }
    },
    fn_openDialogTerm () {
      this.DialogTerm = true
    }
  },
  computed: { ...mapState({ loadingLogin: (state) => state.loadingLogin }) }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200;300;400&display=swap");

@media screen and (min-width: 992px) {
  html {
    overflow: hidden;
  }
}

* {
  font-family: "Kanit", sans-serif;
}

h1 {
  font-weight: 500;
  margin-bottom: 2rem;
}

div#app {
  overflow: hidden;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  background: #fff;
  border-radius: 0.5rem;
  height: 600px;
  width: 510px;
}

.center-card img {
  vertical-align: middle;
}

.center-card {
  margin: 3rem;
}

.container {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.modal-content {
  align-items: center;
  border: none;
  margin: 3rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.btn-secondary,
.btn-secondary:hover,
.btn-secondary:focus {
  color: #1890ff;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 0 0 0.25rem rgb(130 138 145 / 0%);
}

a {
  text-decoration: none;
}

.v-application a {
  color: #154966;
  margin: 1rem 0;
}

span {
  font-weight: 600;
}

.subLogin {
  font-size: 14px;
  color: #077893;
}
.center-card h1 {
  font-size: 1.8rem;
}

p {
  margin: 1rem;
}

button.btn.btn-secondary {
  padding: 0 0 2rem 0;
}

.theme--light.v-btn.v-btn--has-bg {
  color: #fff !important;
  font-weight: 600;
}

.lang {
  top: 15px;
  right: 30px;
  position: absolute;
  margin: 20px;
}

.lang img {
  width: 2rem;
  border-radius: 50%;
}
.borderTitle {
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #077893;
  padding: 10px;
  transition: border 0.3s ease;
}
.borderTitle:hover {
  border: 1px solid #013770; /* Change the border width and color on hover */
}
.fontSize {
  font-size: 14px;
  cursor: pointer;
}
.fontSizeTitle {
  font-size: 16px;
  cursor: pointer;
}
.fontSizeSub {
  font-size: 13px;
  cursor: pointer;
}
.PaddingPolicy {
  padding-bottom: 43px;
}
.p1-submitOTP1 {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0em;
  line-height: 24px;
  text-align: center;
  color: #989898;
}
</style>
